var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShredder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M4.4,14.8c-0.2,0-0.5,0.2-0.5,0.4v17c0,0.3,0.2,0.5,0.5,0.5h9.2v1.9c0,0.3,0.2,0.5,0.5,0.5h2.4 c0.3,0,0.5-0.2,0.5-0.5v-1.9h1.4V37c0,0.3,0.2,0.5,0.5,0.5h2.4c0.3,0,0.5-0.2,0.5-0.5v-4.3h1.5v3.1c0,0.2,0.2,0.5,0.4,0.5h2.5 c0.2,0,0.4-0.3,0.4-0.5v-3.1h1.5V37c0,0.3,0.2,0.5,0.5,0.5h2.4c0.3,0,0.5-0.2,0.5-0.5v-4.3h9.2c0.3,0,0.5-0.2,0.5-0.5v-17 c0-0.2-0.3-0.4-0.5-0.4h-9.2V8c0-0.3-0.2-0.5-0.5-0.5H14.1c-0.3,0-0.5,0.2-0.5,0.5v6.8H4.4z M13.6,28h-2.7v-1.5h2.7V28z M14.4,34.1 v-1.4v-1V29v-0.9v-1.5h1.5v1.5V29v2.7v1v1.4H14.4z M16.9,31.7V29h1.5v2.7H16.9z M16.9,28v-1.5h1.5V28H16.9z M20.8,28.1V29v2.7v1 v3.8h-1.4v-3.8v-1V29v-0.9v-1.5h1.4V28.1z M21.8,31.7V29h1.5v2.7H21.8z M21.8,28v-1.5h1.5V28H21.8z M24.1,35.3v-2.6v-1V29v-0.9 v-1.5h1.5v1.5V29v2.7v1v2.6H24.1z M26.6,31.7V29h1.5v2.7H26.6z M26.6,28v-1.5h1.5V28H26.6z M30.4,28.1V29v2.7v1v3.8h-1.4v-3.8v-1 V29v-0.9v-1.5h1.4V28.1z M14.4,8.5h16v6.3h-16V8.5z M40.1,15.7v16h-8.7V29h3.1c0.3,0,0.5-0.2,0.5-0.5v-2.4c0-0.3-0.2-0.5-0.5-0.5 H10.4c-0.3,0-0.5,0.2-0.5,0.5v2.4c0,0.3,0.2,0.5,0.5,0.5h3.2v2.7H4.9v-16H40.1z M31.4,28v-1.5h2.7V28H31.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 29,
    fill: "#C9C9C9",
    width: 1.5,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.8,
    y: 29,
    fill: "#C9C9C9",
    width: 1.5,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6,
    y: 29,
    fill: "#C9C9C9",
    width: 1.5,
    height: 2.7
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "15.9,32.7 15.9,31.7 15.9,29 15.9,28.1 15.9,26.6 14.4,26.6 14.4,28.1 14.4,29 14.4,31.7  14.4,32.7 14.4,34.1 15.9,34.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "19.4,28.1 19.4,29 19.4,31.7 19.4,32.7 19.4,36.5 20.8,36.5 20.8,32.7 20.8,31.7 20.8,29  20.8,28.1 20.8,26.6 19.4,26.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "25.6,32.7 25.6,31.7 25.6,29 25.6,28.1 25.6,26.6 24.1,26.6 24.1,28.1 24.1,29 24.1,31.7  24.1,32.7 24.1,35.3 25.6,35.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "29.1,28.1 29.1,29 29.1,31.7 29.1,32.7 29.1,36.5 30.4,36.5 30.4,32.7 30.4,31.7 30.4,29  30.4,28.1 30.4,26.6 29.1,26.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9,
    y: 26.6,
    fill: "#A1A1A1",
    width: 2.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.9,
    y: 26.6,
    fill: "#A1A1A1",
    width: 1.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.8,
    y: 26.6,
    fill: "#A1A1A1",
    width: 1.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.6,
    y: 26.6,
    fill: "#A1A1A1",
    width: 1.5,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.4,
    y: 26.6,
    fill: "#A1A1A1",
    width: 2.7,
    height: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F6F6F6",
    d: "M4.9,15.7v16h8.7V29h-3.2c-0.3,0-0.5-0.2-0.5-0.5v-2.4c0-0.3,0.2-0.5,0.5-0.5h24.2c0.3,0,0.5,0.2,0.5,0.5 v2.4c0,0.3-0.2,0.5-0.5,0.5h-3.1v2.7h8.7v-16H4.9z M30.9,17.2c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7 C29.3,18,30,17.2,30.9,17.2z M38.3,17.2c0.9,0,1.7,0.8,1.7,1.7c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7 C36.6,18,37.3,17.2,38.3,17.2z M36.3,18.9c0,0.9-0.8,1.7-1.7,1.7s-1.7-0.8-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7S36.3,18,36.3,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M30.4,14.8V8.5h-16v6.3H30.4z M28.6,13.3H16.4c-0.3,0-0.5-0.2-0.5-0.5c0-0.3,0.2-0.5,0.5-0.5h12.1 c0.3,0,0.5,0.2,0.5,0.5C29.1,13.1,28.8,13.3,28.6,13.3z M16.4,9.9h12.1c0.3,0,0.5,0.2,0.5,0.5c0,0.3-0.2,0.5-0.5,0.5H16.4 c-0.3,0-0.5-0.2-0.5-0.5C15.9,10.1,16.2,9.9,16.4,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M16.4,10.9h12.1c0.3,0,0.5-0.2,0.5-0.5c0-0.3-0.2-0.5-0.5-0.5H16.4c-0.3,0-0.5,0.2-0.5,0.5 C15.9,10.7,16.2,10.9,16.4,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#505050",
    d: "M28.6,12.3H16.4c-0.3,0-0.5,0.2-0.5,0.5c0,0.3,0.2,0.5,0.5,0.5h12.1c0.3,0,0.5-0.2,0.5-0.5 C29,12.5,28.8,12.3,28.6,12.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#28B557",
    d: "M29.3,18.9c0,0.9,0.8,1.7,1.7,1.7c0.9,0,1.7-0.8,1.7-1.7c0-0.9-0.8-1.7-1.7-1.7C30,17.2,29.3,18,29.3,18.9z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4AB8DC",
    d: "M32.8,18.9c0,0.9,0.8,1.7,1.7,1.7s1.7-0.8,1.7-1.7c0-0.9-0.8-1.7-1.7-1.7S32.8,18,32.8,18.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2724A",
    d: "M38.3,20.6c0.9,0,1.7-0.8,1.7-1.7c0-0.9-0.8-1.7-1.7-1.7c-0.9,0-1.7,0.8-1.7,1.7 C36.6,19.8,37.3,20.6,38.3,20.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShredder);
export default __webpack_public_path__ + "static/media/shredder.79335f38907573d73403b1f116e75031.svg";
export { ForwardRef as ReactComponent };